/**
 * Created by tomers on 2/26/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseCollection = require("collections/BaseCollection");
    var IntegrationsRowModel = require("manager-models/data-sources/integrations/IntegrationsRowModel");

    var IntegrationsRowsCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        IntegrationsRowsCollection = BaseCollection.extend({
            model : IntegrationsRowModel,

            getAttributeById: function(attributeId){
                var result = null;
                var attributeModel = null;
                _.each(this.models, function(rowModel){
                    attributeModel = rowModel.getAttributeById(attributeId);
                    if (!_.isEmpty(attributeModel)){
                        result = attributeModel;
                        return;
                    }
                });
                return result;
            },
            areAllPropertiesBlank: function(agent){
                var result = true;
                var iterator = this.models.length;
                var model;

                while (result && iterator) {
                    iterator--;
                    model = this.models[iterator];
                    result = result && model.arePropertiesBlank(agent);
                }
                return result;
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return IntegrationsRowsCollection;
});
